/* global G */
import routeComposition from 'trait/composition/route'

/**
 * Logs the user out when the ok button of the unauthorized dialog is pressed.
 *
 * @param {Gaia.Web.Application} obj  the Web platform Application
 * @returns {(function(): Promise<void>)|*}
 */
const logoutHandler = obj => async () => {
  const { moduleAction } = obj[G.ADAPTER][G.ROUTER][G.API]
  // setting logout route
  const { logout } = obj[G.CONFIGURATION].defaults
  const route = routeComposition(logout.module, logout.action)
  // Redirecting
  await moduleAction(route)
}

export default logoutHandler
